const quotes = document.querySelectorAll('.quote-component, .quote');

quotes.forEach((quote) => {
    const namespace = quote.classList.contains('quote-component') ? 'quote-component' : 'quote';

    const textEl = quote.querySelector(`.${namespace}__text`);
    const readMoreEl = quote.querySelector(`.${namespace}__read-more`);
    const readLessEl = quote.querySelector(`.${namespace}__read-less`);

    checkQuoteTextHeight();

    window.addEventListener('resize', () => {
        checkQuoteTextHeight();
    });

    if (readMoreEl) {
        readMoreEl.addEventListener('click', () => {
            quote.classList.add(`${namespace}--expanded`);
        });
    }

    if (readLessEl) {
        readLessEl.addEventListener('click', () => {
            quote.classList.remove(`${namespace}--expanded`);
        });
    }

    function checkQuoteTextHeight() {
        const isExpanded = quote.classList.contains(`${namespace}--expanded`);
        quote.classList.remove(`${namespace}--expanded`);

        if (textEl) {
            if (textEl.scrollHeight > textEl.offsetHeight) {
                quote.classList.add(`${namespace}--overflow`);
                if (isExpanded) {
                    quote.classList.add(`${namespace}--expanded`);
                }
            } else {
                quote.classList.remove(`${namespace}--overflow`);
            }
        }
    }
});
